export type TranscriptTurn = {
    speaker: 'ai' | 'user' | 'other'
    text: string
}

export const parseTranscript = (transcript: string): TranscriptTurn[] => {
    const turns: TranscriptTurn[] = []
    transcript.split('\n').forEach((raw) => {
        const line = raw.trimEnd()
        if (!line.trim()) return
        if (/^AI:\s*/i.test(line)) {
            turns.push({ speaker: 'ai', text: line.replace(/^AI:\s*/i, '') })
            return
        }
        if (/^User:\s*/i.test(line)) {
            turns.push({
                speaker: 'user',
                text: line.replace(/^User:\s*/i, ''),
            })
            return
        }
        if (turns.length) {
            turns[turns.length - 1].text += `\n${line}`
        } else {
            turns.push({ speaker: 'other', text: line })
        }
    })
    return turns
}

const mergeSpoken = (previous: string, next: string): string => {
    const prev = previous.trim()
    const nxt = next.trim()
    if (!prev) return nxt
    if (!nxt) return prev
    const prevLower = prev.toLowerCase()
    const nextLower = nxt.toLowerCase()
    if (nextLower.startsWith(prevLower) || prevLower.startsWith(nextLower)) {
        return nxt.length >= prev.length ? nxt : prev
    }
    return `${prev} ${nxt}`
}

/** One bubble per turn. Partials from the same speaker stay together. */
export const groupSpeakerTurns = (
    turns: TranscriptTurn[],
): TranscriptTurn[] => {
    const grouped: TranscriptTurn[] = []
    turns.forEach((turn) => {
        const last = grouped[grouped.length - 1]
        if (last && last.speaker === turn.speaker && turn.speaker !== 'other') {
            last.text = mergeSpoken(last.text, turn.text)
            return
        }
        grouped.push({ speaker: turn.speaker, text: turn.text })
    })
    return grouped
}
